import script from "./ShippingHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingHistory.vue?vue&type=script&setup=true&lang=ts"

import "./ShippingHistory.vue?vue&type=style&index=0&id=53cb3bce&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53cb3bce"]])

export default __exports__